<script>
  import AppContentLoader from '../../components/main/ContentLoader'

  import * as restfulService from '../../services/restfulService'

  import bus from '@utils/bus'

  export default {
    name: 'dashboard-novidades',
    components: {AppContentLoader},
    data () {
      return {
        carregandoDados: true,
        conteudoDisponivel: true,
        mostrarModal: false,
        noticia: {
          titulo: '',
          texto: '',
          data: ''
        },
        novidades: []
      }
    },
    mounted () {
      this.buscarNovidades()
    },
    methods: {
      async buscarNovidades () {
        this.carregandoDados = true
        this.conteudoDisponivel = true
        this.novidades.splice(0)
        restfulService.get('dashboard', 'novidades', null, null, null, true)
          .then((response) => {
            if (response.length) {
              this.novidades = [...this.novidades, ...response]
              setTimeout(() => {
                this.carregandoDados = false
              }, 300)
            } else {
              this.carregandoDados = false
              this.conteudoDisponivel = false
            }
          })
          .catch(e => {
            this.carregandoDados = false
            this.conteudoDisponivel = false
            console.log(e)
          })
      },
      mostrarNoticia (item) {
        bus.$emit('show-loader')
        restfulService.get('dashboard/novidades', null, item.id)
          .then((response) => {
            this.noticia = response
            this.mostrarModal = true
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div class="box box-25 has-loading">
        <app-content-loader :is-loading.sync="carregandoDados"/>
        <div class="box-header">
            <div class="box-title">Novidades</div>
            <div class="box-nav">
                <div class="box-icon" @click="buscarNovidades()" title="Recarregar Dados">
                    <i class="fas fa-sync"></i>
                </div>
            </div>
        </div>
        <div class="box-content">
            <div class="box-content-vazio -menor" v-if="!conteudoDisponivel">
                <div>
                    <div class="icon-vazio">
                        <i class="fas fa-newspaper"></i>
                        <i class="fas fa-grin-beam-sweat"></i>
                    </div>
                    <h3>Novidades não disponíveis</h3>
                </div>
            </div>
            <ul class="news" v-if="conteudoDisponivel">
                <li v-for="item in novidades" @click="mostrarNoticia(item)">
                    <figure v-if="item.imagem" class="news-image">
                        <img :src="item.imagem" alt="">
                    </figure>
                    <div class="data">
                        <h4 class="news-title">{{item.titulo}}</h4>
                        <div class="news-datetime">Atualizado em {{item.atualizado_em | dateTimeEnToBr}}</div>
                    </div>
                </li>
            </ul>
        </div>
        <v-dialog v-model="mostrarModal" width="80%">
            <v-card class="modal-noticia">
                <v-card-title class="primary white--text"
                              >
                    {{noticia.titulo}}
                </v-card-title>
                <v-card-text>
                    <v-container fluid grid-list-md>
                        <v-layout row wrap>
                            <v-flex sm4 xs12 v-if="noticia.imagem">
                                <figure class="imagem">
                                    <img :src="noticia.imagem" alt="">
                                </figure>
                            </v-flex>
                            <v-flex sm8 xs12>
                                <div class="modal-noticia-texto" v-html="noticia.texto"></div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat
                           @click="mostrarModal = false">
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<style lang="scss" scoped>
    .news {
        margin: 0;
        padding: 5px 0;
        list-style: none;
        li {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: justify;
            -ms-flex-pack: justify;
            justify-content: space-between;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            margin-bottom: 10px;
            cursor: pointer;

            &:hover,
            &:focus,
            &:active {
                background-color: #eeeeee;
            }

            &:last-child {
                margin-bottom: 0;
            }

            > .news-image {
                width: 80px;
                margin: 0;
                img {
                    display: block;
                    max-width: 100%;
                    min-width: 80px;
                }
            }
            .data {
                padding: 0 15px;
                flex: 1;
                > .news-title {
                    margin: 0;
                    font-weight: 500;
                    font-size: 13px;
                    line-height: 16px;
                }
                > .news-datetime {
                    padding-top: 1px;
                    font-size: 11px;
                }
            }
        }
    }

    .modal-noticia {
        .imagem {
            img {
                display: block;
                max-width: 100%;
                height: auto;
                margin: 0 auto;
            }
            padding-right: 25px;
        }
    }
    .modal-noticia-texto {
        * {
            font-size: 18px !important;
        }
        h1, h2, h3, h4, h5, h6 {
            font-weight: 300 !important;
        }
    }
</style>



// WEBPACK FOOTER //
// Novidades.vue?1e27c394